import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import React, { useState } from "react";
import {
	IconButton,
	PrimaryButton,
	SecondaryButton
} from "@prestosports/commons-ui";
import { StreamProvider } from "@prestosports/prestostats-core/Common";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Save32 from "@carbon/icons-react/lib/save/32";
import Delete32 from "@carbon/icons-react/lib/delete/32";
import { useFormik } from "formik";
import classNames from "classnames";
import commonStyles from "../styles/Common.styles";
import streamListStyles from "../styles/sports/StreamList.styles";

const StreamListItem = ({
	stream,
	index,
	handleSave,
	handleDelete,
	eventId
}) => {
	const classes = streamListStyles();
	const commonClasses = commonStyles();
	const { src, providerId } = stream;

	const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

	const onDelete = (s) => {
		if (s.markers?.length) {
			setDeleteDialogOpen(true);
		} else {
			handleDelete(s);
		}
	};

	const handleCloseDeleteDialog = () => {
		setDeleteDialogOpen(false);
	};

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: "",
			source: providerId || src || "",
			markers: [],
			providerCode: StreamProvider.None,
			eventId,
			...stream
		},
		onSubmit: (values) => {
			const { source, ...rest } = values;
			const isProviderStream = rest.providerCode !== StreamProvider.None;
			handleSave(
				Object.assign(rest, {
					[isProviderStream ? "providerId" : "src"]: source,
					isProviderSrcStale: isProviderStream
				})
			);
		}
	});

	const { handleSubmit, handleChange, values } = formik;
	return (
		<>
			<form
				className={classNames(commonClasses.form, classes.streamListItem)}
				onSubmit={handleSubmit}
			>
				<Grid container spacing={2}>
					<Grid item xs={12} md={4}>
						<TextField
							id="name"
							name="name"
							label="Name"
							fullWidth
							defaultValue={values.name}
							onChange={handleChange}
							required
						/>
					</Grid>
					<Grid item xs={12} md={4}>
						<FormControl variant="outlined" fullWidth>
							<InputLabel htmlFor="providerCode">Provider</InputLabel>
							<Select
								id="providerCode"
								name="providerCode"
								label="Provider"
								value={values.providerCode}
								onChange={handleChange}
								required
							>
								{Object.keys(StreamProvider).map((name) => (
									<MenuItem value={StreamProvider[name]} key={StreamProvider[name]}>
										{name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={12} md={4}>
						<TextField
							id="source"
							name="source"
							label={
								values.providerCode !== StreamProvider.None ? "Provider ID" : "URL"
							}
							fullWidth
							defaultValue={values.source}
							onChange={handleChange}
							required
						/>
					</Grid>
				</Grid>
				<IconButton
					aria-label="Save stream"
					id={`icon-button-save-${index}`}
					type="submit"
				>
					<Save32 />
				</IconButton>
				<IconButton
					aria-label="Delete stream"
					onClick={() => onDelete(stream)}
					id={`icon-button-delete-${index}`}
				>
					<Delete32 />
				</IconButton>
			</form>
			<Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog}>
				<DialogTitle>Stream Contains Markers</DialogTitle>
				<DialogContent>
					Markers exist for this stream, are you sure you want to delete it?
				</DialogContent>
				<DialogActions>
					<SecondaryButton onClick={handleCloseDeleteDialog} label="Cancel" />
					<PrimaryButton
						onClick={() => handleDelete(stream)}
						id="delete-stream-with-markers-btn"
						label="Delete"
					/>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default StreamListItem;
